<template>
    <div>
        <h1 class="mb-4 font-active">Free 15-Day Returns</h1>
            <p>
                At Friendly Diamonds India, we have full confidence that you will adore our products. However, should a situation arise where you feel the need to return any item from your order, we are happy to help! We proudly offer a hassle-free, no-questions-asked 15 Day Return Policy for all orders placed within India, ensuring a full refund for your complete satisfaction.
            </p>

            <h3>Return Shipping</h3>
            <p>
                Friendly Diamonds India offers an insured Free Return Shipping on all eligible items within 15 days of the delivery date (the 15-day timeline begins from the date of order delivery). 
            </p>

            <h3>Return Terms</h3>
            <p>  
                Items that need to be returned must be in unused condition. They should also retain their original packaging and documents, including the <NuxtLink :to="localePath('/blog/know-about-diamond-certification')">diamond certificate</NuxtLink>.
            <br><br>
            <strong>Please note:</strong>
            </p>
            
            <ul>
                <li>In the event that the items are found to be used or worn out, an amount of ₹15,000 will be deducted from the total refund value.</li> 
                <li>If the diamond grading certificate is lost or tampered with, a ₹5,000 replacement fee shall be levied on the refund amount.</li>
                <li>All items that have been engraved will have a deduction of ₹1,500 upon return.</li>
            </ul>
            <p>Returns are not accepted for jewellery that has been resized or altered in any manner. Additionally, products that have already been exchanged cannot be returned and will not be eligible for a second exchange request.</p>

            <h3> Cancellations</h3>
            <p>We offer the ability to cancel an order and get a full refund before shipping. However, bespoke custom designs are not eligible for cancellations after 48 hours of the placement of order.</p><br>

            <h3>How Do You Return Your Order?</h3>
            <h4>Contact the Friendly Diamonds India Customer Service Team</h4>
            <ul>
                <li>If you need to return an item, please contact our India Customer Service team. Kindly email us at <a rel="nofollow noopener" :href="'mailto:'+$country.email">{{$country.email}}</a> with your Order Number and the word "Return" in the subject line. State that you'd like to return the item and provide all the information regarding your return request.</li>
                <li>After we inspect your return request, arrangements for the collection of the order will be made.</li>
            </ul>

            <h3>How to Pack Your Order? </h3>
            <p>Safe and secure packaging is a requirement for all eligible returns to ensure safe transit. Make sure that the actual product and any loose diamonds or metal pieces are securely packed in the original packaging box. While shipping your products, it is mandatory to share the following images with our team:</p>
            <ul>
                <li>Items inside the package (must show the merchandise being returned).</li>
                <li>Outside packaging (must be properly secured).</li>
            </ul>
            <p>Returns are subject to approval based on the quality and accuracy of the provided images. If the images are not shared or get disapproved by our team, your package will not be insured and might lead to insecure transit. In such instances, we will not be responsible for the safety of your parcel. Also, please note:</p>
            <ul>
                <li>For security reasons, ‘jewellery’, ‘diamonds’ or other related words should not be written anywhere on the package.</li>
                <li>Kindly double-box your package for safety purposes.</li>
            </ul>
            <h3>Refund Process</h3>
            <p>
                Once we receive the return parcel, our quality assessment team will examine the item and proceed accordingly. Please note that the customer may receive a follow-up email or inquiry to determine eligibility if the item is not in an unused condition. Once approved, we will initiate the refund process. 
                <br><br>
                Refunds typically process within the window of 5 to 7 business days. Refunded amount will be issued via the mode of payment used in the original purchase. 
            </p>

            <h3>Serial Returns (Bracketing)</h3>
            <p>
                We do not support bracketing or serial returns in order to protect the exquisite craftsmanship, outstanding quality, and equity for all of our customers.
                <br><br>
                Bracketing is the act of buying multiple product variations with the intent of returning the ones that are unwanted. We do not accept returns for orders suspected of being bracket purchases. We rely on your understanding that the trend of over-ordering through bracketing mirrors the issues of over-consumption and sustainability. 
            </p>

    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }

    p{
        font-size: 14px;
    }

    ul li {
        font-size: 14px;
    }
}
</style>